import React, {Component} from 'react'
import IconWarning from '../style/icon/IconWarning'

class DeviceAIN extends Component {
  handleClick(dev) {
    this.props.onClick(dev)
  }
  render() {
    const {icon, device} = this.props
    return <div onClick={() => this.handleClick(device)}>
      <span >{icon}</span>{
        !device.Disconnected
          ? <div className="value">
              <span className="number" style={{
                  color: device.Color
                }}>{Math.round(device.Val / 10)}</span>
              <span className="unit">{device.Unit}</span>
            </div>
          : <div className="value">
              <span className="disconnected"><IconWarning/></span>
              <span className="unit"></span>
            </div>
      }
      <span style={{
          color: device.Color
        }}>{device.Name}</span>
    </div>
  }
}

export default DeviceAIN;



// WEBPACK FOOTER //
// ./src/components/DeviceAIN.js